const css = `.gP1Zsa__tooltipLine{stroke:#5d6f83;stroke-width:1px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"tooltipLine":"gP1Zsa__tooltipLine"};
